import { useTranslation } from 'react-i18next';
import { Banknote, DoorOpen, ShoppingCart, Users } from 'lucide-react';
import { formatMoney } from '@/shared/i18n/formatMoney';
import { SummaryCard } from './SummaryCard';
import { ExpectedAttendanceCard } from './ExpectedAttendanceCard';
import { ADMISSIONS_TODAY, GUESTS_BOOKED_TODAY, ITEMS_SOLD_TODAY, REVENUE_TODAY } from './mockData';

/**
 * Mocked daily-summary dashboard for the Venue workspace home: a top row of metric
 * {@link SummaryCard}s over an {@link ExpectedAttendanceCard} chart. All values are static mock
 * data (see `mockData.ts`); this whole `dashboardPreview/` folder is meant to be replaced once the
 * dashboard is wired to real Booking / Visit / Sale data.
 */
export function DashboardPreview() {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-col gap-4" data-testid="dashboard-preview">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <SummaryCard
          title={t('workspace.dashboard.guestsBooked')}
          value={String(GUESTS_BOOKED_TODAY)}
          hint={t('workspace.dashboard.guestsBookedHint')}
          icon={Users}
        />
        <SummaryCard
          title={t('workspace.dashboard.admissions')}
          value={String(ADMISSIONS_TODAY)}
          hint={t('workspace.dashboard.admissionsHint')}
          icon={DoorOpen}
        />
        <SummaryCard
          title={t('workspace.dashboard.revenue')}
          value={formatMoney(REVENUE_TODAY)}
          hint={t('workspace.dashboard.revenueHint')}
          icon={Banknote}
        />
        <SummaryCard
          title={t('workspace.dashboard.itemsSold')}
          value={String(ITEMS_SOLD_TODAY)}
          hint={t('workspace.dashboard.itemsSoldHint')}
          icon={ShoppingCart}
        />
      </div>
      <ExpectedAttendanceCard />
    </div>
  );
}
